import { useMemo } from "react";
import { ReadCosts } from "@/types/costs";
import { DataTableFeatures } from "@/types/dataTableSettings";
import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useInvoiceSpecificationCostsColumnOverrides } from "./useInvoiceSpecificationCostsColumnOverrides";

export function useInvoiceSpecificationCostsList(
  invoiceSpecificationId: string,
) {
  const options = useCreateDataTableOptions<ReadCosts>("costs");

  const columnOverrides = useInvoiceSpecificationCostsColumnOverrides();

  const tableFeatures = useMemo(
    (): DataTableFeatures => ({
      enableFilters: true,
      enableSorting: true,
    }),
    [invoiceSpecificationId],
  );

  return { options, tableFeatures, columnOverrides };
}
